import { SharedProps } from "../../types/SharedProps";

export type ButtonProps = SharedProps & {
    BtnProps?: BtnProps,
    placeHolder?: string,
    placeHolderStyle?: React.CSSProperties,
    children?: any,
    additionalIcon?:  React.FunctionComponent<React.SVGProps<SVGSVGElement> & {
        title?: string | undefined;
    }>,
    iconPosition?: iconPosition;
    refocus?: boolean;
    setRefocusButton?: Function;
}

export type BtnProps = SharedProps & {
    onClick?: React.MouseEventHandler<HTMLButtonElement>,
    disabled?: boolean
}

export enum classNameBtn {
    Btn = "btn",
    Small = "Small",
    Large = "Large",
    PrimaryDisabled = "PrimaryDisabled",
    SmallSecondary = "SmallSecondary",
    LargeSecondary = "LargeSecondary",
    SecondaryDisabled = "SecondaryDisabled",
    Big = "Big",
    BigSecondary = "BigSecondary",
    SmallWarning = "SmallWarning",
    SmallSuccess = "SmallSuccess",
    SmallPrimaryGray = "SmallPrimaryGray",
    SmallSecondaryGray = "SmallSecondaryGray"
}

export enum iconPosition {
    Start = "start",
    End = "end"
}